

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import Comment from "@/components/Comment.vue";
import { JSONSchema6 } from "json-schema";
import { CPTCommentI } from "@/models/cpt/CPTCommentI";
@Component({
  components: { Comment },
})
/**
 * Handle the whole cpt comment area
 */
export default class CommentArea extends Vue {
  /**
   * An array of comments
   */
  @Prop({ required: true }) readonly comments!: CPTCommentI[];

  /**
   * The Json schema used for comments
   */
  @Prop({ required: true }) readonly jsonSchema!: JSONSchema6;

  /**
   * The Json schema used for comments
   */
  @Prop({ required: true }) readonly baseJsonSchema!: JSONSchema6;

  /**
   * indicate if form shown
   */
  public showAddCommentForm = false;

  /**
   * model for new comments
   */
  public newCommentModel = {};

  /**
   * is comment form valid?
   */
  public commentValid = false;

  /**
   * Form options
   */
  // eslint-disable-next-line
  get formOptions(): any {
    return {
      castToSchemaType: true,
      showValidationErrors: true,
      // https://jarvelov.gitbook.io/vue-form-json-schema/api/vue-form-json-schema/options/ajv
      ajv: {
        options: {
          schemas: [this.baseJsonSchema],
        },
      },
    };
  }

  /**
   * set comment form initial state
   */
  beforeMount(): void {
    this.resetCommentModel();
  }

  /**
   * reset the comment form
   */
  resetCommentModel(): void {
    this.newCommentModel = {
      data: {
        title: "",
        content: "",
        type: "comment",
      },
    };
  }

  /**
   * update the forms valid value
   */
  public onValidated(valid: boolean): void {
    this.commentValid = valid;
  }

  /**
   * add a new comment
   */
  async addComment(): Promise<void> {
    if (this.commentValid) {
      this.$emit("add-comment", this.newCommentModel);
      this.showAddCommentForm = false;
      this.resetCommentModel();
    }
  }

  /**
   * invert show comment form bool
   */
  invertShowNewComment(): void {
    this.showAddCommentForm = !this.showAddCommentForm;
  }

  /**
   * fetch the ui schema to build
   * the form from
   */
  // eslint-disable-next-line
  get uiSchema(): any {
    return [
      {
        component: "div",
        fieldOptions: {
          class: ["form-group", "col-12"],
        },
        children: [
          {
            component: "label",
            fieldOptions: {
              attrs: {
                for: "title",
              },
              class: ["font-weight-bold"],
              domProps: {
                innerHTML: this.$i18n.t("components.commentArea.title"),
              },
            },
          },
          {
            component: "gitlify-text-input",
            model: "data.title",
            errorOptions: {
              class: ["is-invalid"],
            },
            fieldOptions: {
              attrs: {
                id: "title",
              },
              on: ["input"],
            },
          },
        ],
      },
      {
        component: "div",
        fieldOptions: {
          class: ["form-group", "col-12"],
        },
        children: [
          {
            component: "label",
            fieldOptions: {
              attrs: {
                for: "content",
              },
              class: ["font-weight-bold"],
              domProps: {
                innerHTML: this.$i18n.t("components.commentArea.content"),
              },
            },
          },
          {
            component: "gitlify-markdown-editor",
            model: "data.content",
            errorOptions: {
              class: ["is-invalid"],
            },
            fieldOptions: {
              on: ["input"],
            },
          },
        ],
      },
    ];
  }
}
